import React from "react";

import { EuiAvatar, EuiIcon, EuiToolTip } from "@elastic/eui";
import _ from "lodash";
import toEnName from "arabic-name-to-en";
import { euiColorVis0, euiLinkColor } from "@elastic/eui/dist/eui_theme_light.json";
import { EntityLinkWrapper } from "./style";

const renderBoolValue = (flag) => (
    <EuiIcon
        color={flag ? "success" : "subdued"}
        type="checkInCircleFilled"
        size="m"
    />
);

const renderEntityValue = (value) => {
    if (typeof value === "boolean") {
        return renderBoolValue(value);
    }

    if (_.isNil(value)) {
        return "N/A";
    }

    return value;
};

function EntityLink({ entity, options: { name, previewOptions }, lineThrough, hideAvatar }) {
    return (
        <EuiToolTip
            position="top"
            content={previewOptions.map((option) => (
                <span key={option}>
                    <b>{_.startCase(option)}</b>: {renderEntityValue(entity[option])}
                    <br />
                </span>
            ))}
        >
            <EntityLinkWrapper lineThrough={lineThrough}>
                <span className="eui-displayInline avatar-container">
                    {!hideAvatar && (
                        <EuiAvatar
                            size="m"
                            name={toEnName(entity[name])}
                            color={entity.type === "admin" ? euiColorVis0 : euiLinkColor}
                        />
                    )}
                </span>
                <span>{entity[name]}</span>
            </EntityLinkWrapper>
        </EuiToolTip>
    );
}

export default EntityLink;
